import classNames from 'classnames'
import { h, JSX } from 'preact'

export interface ImageProps {
    modifier?: string
    class?: string
    srcset: string
    sizes?: string
    alt?: string
}

export const Image = (props: ImageProps): JSX.Element => {
    return (
        <div class={classNames('image', props.modifier, props.class)}>
            <img
                class="image__img"
                src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
                srcset={props.srcset}
                sizes={props.sizes}
                alt={props.alt}
            />
        </div>
    )
}
